import * as api from "./GDR.api";
import * as queries from "./GDR.queries";

export default { ...api, ...queries };
